
import { computed, defineComponent } from "vue";
import { useQRCode } from "@vueuse/integrations";

export default defineComponent({
  name: "Home",
  setup() {
    const lineUrl = computed(() => {
      return window.origin.includes("api.haadthip.com")
        ? "https://line.me/R/ti/p/%40839clgex"
        : window.origin.includes("apiqas.haad")
        ? "https://line.me/R/ti/p/%40772eanfg"
        : "https://line.me/R/ti/p/%40839clgex";
    });
    const qrcode = useQRCode(lineUrl.value);
    return { qrcode, lineUrl };
  },
});
